// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__24pS4","location":"Header_location__10ZKS"};